import { searchAlertResults, searchAlertHitDetailsResults } from '@Services/AlertResults';
import { _resolveAuth, _goToQuickSearch } from './utils';

export const resolveUserAlert = _resolveAuth((...args) =>
  searchAlertResults(...args).catch(() => {
    _goToQuickSearch();
  })
);

export const resolveUserAlertHitDetails = _resolveAuth((...args) =>
  searchAlertHitDetailsResults(...args).catch(() => {
    _goToQuickSearch();
  })
);
